import { useEffect } from 'react';
import {
  Heading,
  ContentPageLayout,
  ContentRowsLayout,
} from '@nbcuniversal-paint/nbcu-react-components';
import { useParams } from 'react-router-dom';
import Page from '../../components/Page';
import strings from '../../translations';

import styles from './Schedule.module.scss';
import ScheduleList from '../../containers/ScheduleList';

import BannerImage from '../../components/BannerImage';
import scifiBanner21x9 from '../../assets/images/hero/syfyfr/21x9.jpg';
import scifiBanner4x5 from '../../assets/images/hero/syfyfr/4x5.jpg';
import tstreetBanner16x9 from '../../assets/images/hero/13thstreetfr/16x9.png';
import tstreetBanner4x5 from '../../assets/images/hero/13thstreetfr/4x5.png';

const { TITLE } = strings.PAGES.HOME;

const Schedule = () => {
  const params = useParams();
  const { id } = params;

  const isSyfy = import.meta.env.VITE_LOCALE === 'syfyfr';
  const is13thStreet = import.meta.env.VITE_LOCALE === '13thstreetfr';

  useEffect(() => {
    const script = document.createElement('script');

    script.src = import.meta.env.VITE_CDN_SRC || '';
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.setAttribute(
      'data-domain-script',
      import.meta.env.VITE_COOKIE_ID || '',
    );
    script.integrity = import.meta.env.VITE_COOKIE_INTEG || '';
    script.crossOrigin = 'anonymous';
    script.setAttribute('data-document-language', 'true');

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  if (!id) {
    return null;
  }

  return (
    <>
      {isSyfy && (
        <picture>
          <source srcSet={scifiBanner4x5} media="(max-width: 600px)" />
          <BannerImage image={scifiBanner21x9} />
        </picture>
      )}
      {is13thStreet && (
        <picture>
          <source srcSet={tstreetBanner4x5} media="(max-width: 600px)" />
          <BannerImage image={tstreetBanner16x9} />
        </picture>
      )}
      <Page title={TITLE}>
        <ContentPageLayout spacing="none" flush>
          <ContentRowsLayout>
            <Heading tag="h1" className="sr-only">
              {TITLE}
            </Heading>

            <div className={styles.layout}>
              <ScheduleList currentDate={id} />
            </div>
          </ContentRowsLayout>
        </ContentPageLayout>
      </Page>
    </>
  );
};

export default Schedule;
